export const HOME_CONTENT = {
  hero: {
    eyebrow: 'Singapore · Licensed specialists',
    title: 'A quieter kind of',
    titleAccent: 'sacred journey',
    subtitle: 'Refined Umrah and Hajj from Singapore — considered hotels, unhurried guidance, and care in every detail.',
    primaryButton: 'Explore packages',
    secondaryButton: 'Plan with an advisor',
    image: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1920&h=1080&fit=crop',
  },
  stats: [
    { value: '10K+', label: 'Pilgrims served' },
    { value: '15+', label: 'Years in service' },
    { value: '4.9★', label: 'Guest rating' },
  ],
  marquee: [
    'Licensed TA00898',
    'UEN 199402129H',
    '15+ Years of Care',
    '24/7 Pilgrim Support',
    'Premium Haram Hotels',
    'Singapore Based',
  ],
  about: {
    eyebrow: 'Our house',
    title: 'Crafted for those who travel with intention',
    paragraphs: [
      'For over fifteen years TM Fouzy has arranged Umrah and Hajj with the same quiet discipline: honest pricing, considered hotels, and a team that stays with you until you are home.',
      'Every itinerary is built around worship first — then comfort, then logistics. Nothing hurried. Nothing leftover.',
    ],
    highlights: ['Government licensed', 'Expert guides', 'Haram-side stays'],
    cta: 'Our story',
    image: 'https://images.unsplash.com/photo-1564769625905-50e93615e769?w=900&h=700&fit=crop',
    badgeValue: '15+',
    badgeLabel: 'Years of excellence',
  },
  journeys: { eyebrow: 'Journeys', title: 'Choose your path' },
  featured: { eyebrow: 'Curated', title: 'Featured packages', cta: 'View the collection' },
  shop: { eyebrow: 'Atelier', title: 'Travel essentials' },
  why: {
    eyebrow: 'The standard',
    title: 'Why pilgrims choose us',
    items: [
      { title: 'Licensed & verified', desc: 'Fully authorised travel agency with Singapore credentials.' },
      { title: 'Considered pricing', desc: 'Transparent packages with flexible payment options.' },
      { title: 'Guided with care', desc: 'Experienced leaders for every ritual and transfer.' },
      { title: 'Haram-side hotels', desc: 'Stays chosen for proximity, quiet, and rest.' },
      { title: 'Seamless movement', desc: 'Airport to hotel to ziyarah, without the scramble.' },
      { title: 'Always reachable', desc: 'Round-the-clock support before, during, and after.' },
    ],
  },
  testimonials: {
    eyebrow: 'Voices',
    title: 'What our pilgrims say',
    items: [
      { name: 'Ahmad Abdullah', review: 'Alhamdulillah, the entire Umrah journey was smooth and well-organized. Hotels were close to Haram and the guides were knowledgeable.', pkg: 'Umrah Premium' },
      { name: 'Fatima Hassan', review: 'Everything was taken care of from visa to accommodation. The team was responsive and helpful throughout.', pkg: 'Hajj Deluxe' },
      { name: 'Ibrahim Mohamed', review: 'Professional service and great value. The group was well-managed and we had a wonderful spiritual experience.', pkg: 'Umrah Economy' },
    ],
  },
  process: {
    eyebrow: 'Process',
    title: 'How booking works',
    steps: [
      { step: '01', title: 'Choose a package', desc: 'Compare dates, hotels, and prices at your pace.' },
      { step: '02', title: 'Add travellers', desc: 'Enter passport details securely online.' },
      { step: '03', title: 'Pay your way', desc: 'PayNow, transfer, or card — with instalments.' },
      { step: '04', title: 'Travel supported', desc: 'Documents and 24/7 care until you return.' },
    ],
  },
  faq: {
    eyebrow: 'Guidance',
    title: 'Questions, answered',
    items: [
      { q: 'What documents do I need for Umrah?', a: 'A passport with at least 6 months validity, photos, and vaccination records. We handle visa processing and guide you through every document.' },
      { q: 'How far in advance should I book?', a: 'We recommend 2–3 months ahead, especially for peak seasons and Hajj, to secure preferred hotels and flights.' },
      { q: 'What is included in the package price?', a: 'Typically flights, hotels, ground transport, visa, and guided ziyarah. Exact inclusions are listed on each package page.' },
      { q: 'Can I pay in instalments?', a: 'Yes. Pay a deposit to confirm, then settle the balance from your dashboard via PayNow or bank transfer.' },
    ],
  },
  contact: {
    eyebrow: 'Always reachable',
    title: 'Talk to us, any way you prefer',
    subtitle: 'Call, message, or follow — our team replies quickly during office hours, and WhatsApp stays open for pilgrims on the road.',
  },
  blog: { eyebrow: 'Knowledge', title: 'Latest from the blog', cta: 'All articles' },
  cta: {
    eyebrow: 'Begin when you are ready',
    title: 'The journey is waiting',
    subtitle: 'Speak with our team, or browse packages at your leisure.',
    primaryButton: 'Browse packages',
    secondaryButton: 'Contact us',
    image: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1600&h=700&fit=crop',
  },
};

export const ABOUT_CONTENT = {
  hero: {
    title: 'About Us',
    subtitle: 'Your trusted partner for spiritual journeys since 2010',
  },
  story: {
    title: 'Our Story',
    paragraphs: [
      'Founded in 2010, our agency has been dedicated to providing exceptional Umrah and Hajj experiences for pilgrims from around the world. What started as a small family business has grown into one of the most trusted names in Islamic travel.',
      "We understand that performing Umrah or Hajj is a once-in-a-lifetime experience for many. That's why we've made it our mission to ensure every aspect of your journey is handled with care, professionalism, and deep respect for the spiritual significance of your pilgrimage.",
      "Over the years, we've helped more than 10,000 pilgrims fulfill their spiritual obligations, and we continue to innovate and improve our services to meet the evolving needs of modern travelers.",
    ],
    image: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=800&h=600&fit=crop',
  },
  mission: {
    icon: '🎯',
    title: 'Our Mission',
    text: 'To provide seamless, affordable, and spiritually enriching pilgrimage experiences that allow our clients to focus entirely on their worship and spiritual growth, while we handle all the logistics and details.',
  },
  vision: {
    icon: '👁️',
    title: 'Our Vision',
    text: "To be the world's most trusted and preferred Islamic travel agency, known for our exceptional service, integrity, and commitment to making the sacred journey accessible to all Muslims.",
  },
  values: {
    title: 'Our Core Values',
    subtitle: 'The principles that guide everything we do',
    items: [
      { icon: '🤝', title: 'Integrity', text: 'We operate with complete transparency and honesty in all our dealings' },
      { icon: '⭐', title: 'Excellence', text: 'We strive for the highest quality in every service we provide' },
      { icon: '❤️', title: 'Compassion', text: 'We treat every pilgrim with care, respect, and understanding' },
    ],
  },
  stats: [
    { value: '10K+', label: 'Happy Pilgrims' },
    { value: '15+', label: 'Years Experience' },
    { value: '50+', label: 'Packages Available' },
    { value: '4.9★', label: 'Customer Rating' },
  ],
  team: {
    title: 'Our Team',
    subtitle: 'Experienced professionals dedicated to your journey',
    members: [
      { name: 'Ahmad Abdullah', role: 'Founder & CEO', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop' },
      { name: 'Fatima Hassan', role: 'Operations Director', image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop' },
      { name: 'Ibrahim Khan', role: 'Customer Relations', image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop' },
    ],
  },
  certifications: {
    title: 'Licensed & Certified',
    subtitle: 'Fully authorized and regulated',
    items: [
      { icon: '✓', title: 'Government Licensed', text: 'UEN: 199402129H' },
      { icon: '🏆', title: 'Industry Certified', text: 'Member of Travel Agents Association' },
      { icon: '🛡️', title: 'Insured & Protected', text: 'Full travel insurance coverage' },
    ],
  },
  cta: {
    title: 'Ready to Begin Your Journey?',
    subtitle: 'Join thousands of satisfied pilgrims who trusted us with their sacred journey',
    primaryButton: 'Browse Packages',
    secondaryButton: 'Contact Us',
  },
};

export const PAGE_DEFAULTS = {
  home: HOME_CONTENT,
  about: ABOUT_CONTENT,
};

export function mergePageContent(defaults, saved) {
  if (saved == null) return defaults;
  if (Array.isArray(defaults)) return Array.isArray(saved) ? saved : defaults;
  if (typeof defaults !== 'object' || defaults === null) {
    return saved === undefined || saved === null ? defaults : saved;
  }
  if (typeof saved !== 'object' || Array.isArray(saved)) return defaults;
  const merged = { ...defaults };
  Object.keys(saved).forEach((key) => {
    const value = saved[key];
    if (value == null) return;
    const current = defaults[key];
    if (Array.isArray(value)) merged[key] = value;
    else if (value && typeof value === 'object' && current && typeof current === 'object' && !Array.isArray(current)) {
      merged[key] = mergePageContent(current, value);
    } else {
      merged[key] = value;
    }
  });
  return merged;
}
